import { render, staticRenderFns } from "./UsuarioClave.vue?vue&type=template&id=70c4b0f6&scoped=true"
import script from "./UsuarioClave.vue?vue&type=script&lang=js"
export * from "./UsuarioClave.vue?vue&type=script&lang=js"
import style0 from "./UsuarioClave.vue?vue&type=style&index=0&id=70c4b0f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c4b0f6",
  null
  
)

export default component.exports